<template>
  <nav class="nav-extended" style="margin-bottom: 1rem">
    <div class="nav-wrapper">
      <a href="/" class="brand-logo left"
        > <i class="material-icons large">home</i> SOLTAR <small>{{ $route.name }}</small></a
      >

      <ul id="nav-mobile " class="right">
        <li>
          <a class="mdi mdi-chevron-left" @click="$router.back()" >ATRÁS</a>
        </li>
      </ul>
    </div>
    <div class="nav-content" style="color: black !important">
      <ul class="tabs tabs-fixed-width" style="height: 85px;">
        <li class="tab">
          <a class="active" href="#recepcion-cartones">RECEPCIÓN DE CARTONES</a>
        </li>
        <li class="tab">
          <a href="#entrega-cartones">ENTREGA A CLIENTES</a>
        </li>
        <li class="tab">
          <a href="#devolucion-cartones">DEVOLUCION DE CARTONES</a>
        </li>
        <li class="tab">
          <a href="#inventario">INVENTARIO</a>
        </li>
      </ul>
    </div>
  </nav>

  <div class="container">
    <div class="flow-text row">
      <div class="col left"></div>
      <div class="col right">
        <AlmacenShipviaSelector
          @almacen-shipvia="
            (val) => {
              almacen = val.almacen;
              shipvia = val.shipvia;
            }
          "
        ></AlmacenShipviaSelector>
      </div>
    </div>
    <div class="">
      <div id="recepcion-cartones">
        <CartonesRecepcion
          :db="db"
          :cartons="cartons"
          :shipvia="shipvia"
          :shipvias="shipvias"
          :almacen="almacen"
        ></CartonesRecepcion>
      </div>
      <div id="entrega-cartones">
        <FormularioEntregaCliente
          :db="db"
          :cartons="cartons"
          :shipvia="shipvia"
          :almacen="almacen"
          :shipvias="shipvias"
        ></FormularioEntregaCliente>
      </div>
      <div id="devolucion-cartones">
        <FormularioDevolucion
          :db="db"
          :cartons="cartons"
          :shipvia="shipvia"
          :almacen="almacen"
          :shipvias="shipvias"
        ></FormularioDevolucion>
      </div>
      <div id="inventario">
        <Inventario
          :db="db"
          :cartons="cartons"
          :shipvia="shipvia"
          :almacen="almacen"
          :shipvias="shipvias"
        ></Inventario>
      </div>
    </div>
    <div class="card-content">
      <QRScaner
        @cartons="cartons_scaned"
        @limpiar_cartons="
          () => {
            cartons = {};
          }
        "
        :shipvias="shipvias"
        :db="db"
        :cartons="cartons"
      ></QRScaner>
    </div>
  </div>
</template>
<script>
import FormularioDevolucion from "./formulario_devolucion";
import FormularioEntregaCliente from "./formulario_entrega_cliente";
import CartonesRecepcion from "./formulario_recepcion";
import AlmacenShipviaSelector from "../almacen-shipvia-selector";
import Inventario from "./inventario.vue";
import QRScaner from "../qr-carton-escaner";
import M from "materialize-css";
import firebase from "firebase/app";

export default {
  components: {
    FormularioDevolucion,
    FormularioEntregaCliente,
    CartonesRecepcion,
    AlmacenShipviaSelector,
    QRScaner,
    Inventario,
  },
  props: {},

  data() {
    let almacenes = JSON.parse(window.localStorage.getItem("almacenes"));
    let shipvias = JSON.parse(window.localStorage.getItem("shipvias"));
    return {
      db: firebase.firestore(),
      user: window.user,
      almacenes: almacenes,
      shipvias: shipvias,
      shipvia: undefined,
      almacen: undefined,
      cartons: {},
    };
  },

  created() {
    document.addEventListener("limpiarEscaneos", this.limpiarEscaneos);

    setTimeout(() => {
      M.AutoInit();
    }, 0);
  },
  methods: {
    cartons_scaned(cartons) {
      console.log("cartones", cartons);
      this.cartons = cartons;
      window.cartons = cartons;
      this.$forceUpdate();
    },
    limpiarEscaneos() {
      this.cartons = {};
      this.$forceUpdate();
    },
    setShipvia(shipvia) {
      this.shipvia = shipvia;
    },

    signOut() {
      firebase.auth().signOut();
    },
    save() {},
  },
};
</script>